import { Button, Card, CardActionArea, CardContent, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getEstadisticasGenerales, DescargarExcelGenerales } from '../../../actions/miOspedyc/estadisticasMiOspedyc';
import CardGeneralesTotalTurnos from './CardGeneralesTotalTurnos';
import CardGeneralesTotalUsuarios from './CardGeneralesTotalUsuarios';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { ValidatorForm } from 'react-material-ui-form-validator';
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from '../../../hooks/useForm';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    cardIn: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: "outset",
        borderTopWidth: "thick",
        borderRadius: 10,
    }
}));

const GeneralesScreen = () => {
    const classes = useStyles();
    const dispatch = useDispatch()

    const { generales } = useSelector(state => state.estadisticasMiOspedyc)

    const [
        formValues,
        ,
        reset,
        setearValor,
    ] = useForm({
        fechaDesde: "",
        fechaHasta: ""
    });

    const { fechaDesde, fechaHasta } = formValues;

    const downloadExcel = () => {
        dispatch(DescargarExcelGenerales());
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(getEstadisticasGenerales(moment(fechaDesde).format("YYYY-MM-DD"), moment(fechaHasta).format("YYYY-MM-DD")));
    }

    useEffect(() => {
        if(Object.keys(generales).length === 0) {
            dispatch(getEstadisticasGenerales())
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        ValidatorForm.addValidationRule("isAfterOrSameFechaDesde", (value) => {
            if (moment(fechaDesde).isSameOrAfter(moment(value), "day")) {
              return false;
            }
            return true;
          });
    });

    

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Card style={{ padding: "1rem", marginBottom:"1rem" }}>
                        <ValidatorForm onSubmit={handleSubmit}>
                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                        <ValidatedDatePicker
                                            fullWidth
                                            margin="normal"
                                            label="Fecha Desde"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            maxDate={new Date()} //maxDate
                                            clearLabel="Limpiar"
                                            cancelLabel="Cancelar"
                                            value={moment(fechaDesde).isValid() ? moment(fechaDesde) : null}
                                            onChange={(date) => {
                                                setearValor("fechaDesde", date);
                                            }}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                            validators={["required"]}
                                            errorMessages={["La fecha desde es requerida"]}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={4}>
                                    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                        <ValidatedDatePicker
                                            fullWidth
                                            margin="normal"
                                            label="Fecha Hasta"
                                            format="dd/MM/yyyy"
                                            okLabel="Aceptar"
                                            //minDate={new Date()} //maxDate
                                            clearLabel="Limpiar"
                                            cancelLabel="Cancelar"
                                            value={
                                                moment(fechaHasta).isValid()
                                                    ? moment(fechaHasta)
                                                    : null
                                            }
                                            onChange={(date) => {
                                                setearValor("fechaHasta", date);
                                            }}
                                            KeyboardButtonProps={{
                                                "aria-label": "change date",
                                            }}
                                            validators={["required", "isAfterOrSameFechaDesde"]}
                                            errorMessages={["La fecha Hasta es requerida", "La fecha hasta debe ser igual o posterior a la fecha desde"]}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={4} style={{alignSelf:"center", textAlign:"end"}}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        style={{marginRight:10}}
                                    >
                                        Filtrar
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            reset()
                                            dispatch(getEstadisticasGenerales())
                                        }}
                                    >
                                        Limpiar filtros
                                    </Button>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ color: "#fff" }}>Generales
                        <Button
                            component="span"
                            variant="contained"
                            color="primary"
                            style={{ borderRadius: "3px 0px 0px 3px", float: "right" }}
                            startIcon={<CloudDownloadIcon />}
                            onClick={downloadExcel}
                        >
                            Descargar
                        </Button>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.ingresosMobile}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Ingresos Mobile</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.ingresosDesktop}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Ingresos Desktop</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <CardGeneralesTotalUsuarios showLabelFilter={fechaDesde !== "" && fechaHasta !== ""} />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <CardGeneralesTotalTurnos showLabelFilter={fechaDesde !== "" && fechaHasta !== ""} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ color: "#fff", marginTop: "1rem" }}>Funcionalidades</Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadCredencial}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Credenciales</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadTurnos}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Turnos</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadCartillaMedica}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Cartilla Médica</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadFormularios}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Formularios</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadFarmacias}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Farmacias</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                    <Card variant="outlined" className={classes.cardIn}>
                        <CardActionArea>
                            <CardContent>
                                <Typography variant="h6" color="secondary" align="center">{generales.funcionalidadContactos}</Typography>
                                <Typography variant="h6" color="secondary" align="center">Contactos</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default GeneralesScreen
